<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-flex class="xs12 sm12 md12">
    <v-flex v-if="tableTitle!==''" :class="['py-2 tableHeader tableHeaderBottom text-center',trBgClass]">
      {{ tableTitle }}
    </v-flex>
    <div class="clinic-table-container">
      <div class="table-header" v-if="clinicHeaders.length > 0">
        <div v-for="(header, index) in clinicHeaders" :key="index"
             :class="['header-cell', 'text-center', trBgClass, index === 0 ? 'first-column-header' : '']" style="width: 12.5%; min-width: 90px; box-sizing: border-box;">
          <span v-html="header.text"></span>
        </div>
      </div>
      <div v-for="(item, rowIndex) in clinicData" :key="rowIndex" class="table-row">
        <!-- 固定第一列 -->
        <!--<div :style='item.clinicName.length<=4?"width: 12.5%;min-width:85px":"min-width: 90px"'
             :class="['cell', 'clinic-cell', 'text-center', trBgClass]">{{ item.clinicName }}</div>-->
        <div
            :class="['cell', 'clinic-cell', 'text-center', 'fixed-left']"
            style="width: 12.5%; min-width: 90px; box-sizing: border-box;"
        >
          {{ item.clinicName }}
        </div>
        <!-- 使用map循環生成七列 -->
        <div v-for="colIndex in 7" :key="colIndex"
             @click="linkUrl(item[`viewItemUrl${colIndex}`])"
             :class="[
               'cell',
               'data-cell',
               'text-center',
               item[`viewItemMarkFlag${colIndex}`] !== '' ? 'iconSmallFont' : '',
               item[`viewItemUrl${colIndex}`] !== '' && isLink(item[`viewItemUrl${colIndex}`]) ? 'linkName' : ''
             ]" style="width: 12.5%; min-width: 90px; box-sizing: border-box;">
          <div>
            <div class="hideDivName iconSmallFont">{{ item[`viewItemExtName${colIndex}`] }}</div>
            <div class="divName">
              <!-- 各種標記圖標 -->
              <img v-show="item[`viewItemMarkFlag${colIndex}`] !== '' && item[`viewItemMarkFlag${colIndex}`].indexOf('#') > -1"
                   style="width: 15px" src="../../../assets/images/regMarkFlag/full.png">
              <img v-show="item[`viewItemMarkFlag${colIndex}`] !== '' && item[`viewItemMarkFlag${colIndex}`].indexOf('*') > -1"
                   style="width: 15px" src="../../../assets/images/regMarkFlag/noReg.png">
              <img v-show="item[`viewItemMarkFlag${colIndex}`] !== '' && item[`viewItemMarkFlag${colIndex}`].indexOf('R') > -1"
                   style="width: 15px" src="../../../assets/images/regMarkFlag/replaceDoc.png">
              <img v-show="item[`viewItemMarkFlag${colIndex}`] !== '' && item[`viewItemMarkFlag${colIndex}`].indexOf('S') > -1"
                   style="width: 15px" src="../../../assets/images/regMarkFlag/sixColorFlag.png">
              {{ item[`viewItemName${colIndex}`] }}
            </div>
          </div>
        </div>
      </div>
      <!-- 無數據提示 -->
      <div v-if="clinicData.length === 0" class="no-data">
        <v-alert :value='loading' type="warning" icon="mdi-alert-circle">
          查詢中...
        </v-alert>
        <v-alert :value='!loading' color="info" icon="mdi-information">
          表格中沒有內容
        </v-alert>
      </div>
    </div>
  </v-flex>
</template>

<script>
export default {
  name: "ClinicTable",
  data() {
    return {
      loadingText: '查詢中...'
    }
  },
  props: {
    clinicData: {
      type: Array,
    },
    clinicHeaders: {
      type: Array
    },
    loading: {
      type: Boolean,
      default: false
    },
    tableTitle: {
      type: String,
      default: '',
    },
    goWhere: {
      type: String,
      default: '',
    },
    trBgClass: {
      type: String,
      default: '',
    }
  },
  methods: {
    setMarkIcon(mark) {
      let imgSrc = '';
      switch (mark) {
        case '#'://額滿
          imgSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAArFJREFUeNq0VU1ME0EUfltWQNS2UGLiAayeMS1nTMSjmihHNSb2aMKlnkz0YDlo4sl6MMFbDyZcGw9eLYmcWULvVkg0mKDdKijlZ5xvum+Y2e4SCPqS6Uxnd9+8973ve+MIIQj21cmU5FSUI0XHM1+O8jmxDn/k4ADp3JPrHP1bW5KH5BNB5IdyfiJ/qWsvkU6pEWE5+E4EsGhLV17TYPVtl7Nk+TkNL9a69odq79SIsaIbxrwnO0K9Vyao/9Y12nj1hkTTV/v9U9fVfKr4gHYbK/tZ5cbUfKb0SM3b3jL9qb7nxyn6QkPCHGvZvNiqfRSwtrcsjmr4xvTn4Ccqt97JCWrXFtTMECHa1sMnKkq2zIcOPOtXb6p5x6vTXpA1zI0DD87NmaE6WbhDiWoHVdeoB78XNjccNYr4uzJnRQEDrqgNsmDc2XY/r8Yyz4II7EFxhd+iZmHaLJamqZNOarjiYInN4FfphXQyRj3nRyRrbqgDAMmAHNZH2VGLOTqTxir9lD5MlkUWGZFyIaUajyRfkGCjPLsvxKiXTJYwxmuDF+nbhXG0FWrPL3D/0nvQDCvbUvphokLKpyUcZz8tatqy+LAHqERMDSIPgFqHvXlrD8xCJn2Tl41M6yob89ADi9xpFaOUfPlMr3WxJHtQfHMPUYO6YF2cDroyYMZsL9UtNgwU7mpYnADnvqA/OamkXndZuBftNFZUT/lRmFb/YbznFx8LyXfdd7DerMypwSZpavmzIALnAQNS3jJEBhGBehhccAjt+9Q9JTL9/f3bB0PEBYTATGWK4AB+xowB7ngPkDnRl44qss93ApxAA2CMdi6z2Wu2QjqpWw4z8sJB5rBN41v4hpJxZT6NoxlYg4jDvQaC4j2sXdliInrSzP+/9IN+k8dpAVzHNfiYCXzSXwEGAHC4xRcz0rBdAAAAAElFTkSuQmCC';
          break;
        case '*'://不允許掛號
          imgSrc = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAgdJREFUeNq8Vj1PAkEQnUNUCApEbSxUfoCG6ymkVaNSaqKRTo0mUmlhARSa2GFhoh1WWKqJ2lJoLQR+gB+JxgSUwyCfsu6sxwW8WwIiTrLZ2dzw3szs7lsEQgigPQv9Pjp56LBAaybRERgkScQDAQkoeIT6dvhbi1ISUSdn/tfgaHbEFp6gL8VrS4dtGEyeFTC4JqFjZKjmW+7sCnKnF5ANhuq2CwmI1pde3xb0eDeVdTEaB5KSmN8pjoFgMTP/8/4R3lyLUIzEtCmQ4Of4CIZIxd59e+TFJqpiXl0LpBCJsZhySmJrLSxVBebALpg2loFIaUg6Z/iZyZUM3IaZz4vXVS+6nI6mwPvD50qbsGXmwI4qrobA5FllM21LQ+AImj0+gYQ4zki6xh0sSU0CndUChtkJln0mcNgweMq9BnQPlN8YXFPaBHpxlM358E1T4MqxPb2UY0b5LUIrcVpTD5ztw92DEleX4Dfg1VaW7wqXQP8jg0bB8dZXV6IiKEXibO6mpwA3vNnMUU7YjZdxVARYGuoLghnd802BY0KoWd+bfcGXioRzWrn6ONBQNrQkQEta8uFr1beaPSjQI5rZP2JZ48CK6mWOZg0egHFpjt2ftGe7fWKH1Tckdjy5RimonBCUhGoZl9zrXGn5lwcHn0wvtMf87X/00UMH2eS/HK0aYvhlTPgSYACrua5sWl5+rwAAAABJRU5ErkJggg==';
          break;
        default:
      }
      return imgSrc;
    },
    addLink(name, url, divName) { //醫師連結 URL
      let link = divName + "<br/>" + '<span style="color: blue;font-weight: bold">' +
          name + '</span>';
      return url == '' ? name : link;
    },
    splitURL(name, url) {
      return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(this.$store.state.AppSetting.backSrvUrl + "?" + url) || [""])[1].replace(/\+/g, '%20')) || null;
    },
    isLink(url) {
      if (url !== "") {
        let today = this.$UtilityJs.AD2ROC_DateTime(new Date().toISOString(), 'date');
        let daySplit = today.split("-")
        let nowDay = (daySplit[0] - 1911) + "" + daySplit[1] + "" + daySplit[2];//今天民國年
        let viewDate = this.splitURL('viewDate', url);
        if (viewDate < nowDay) {
          return false
        } else {
          return true;
        }
      } else {
        return true;
      }
    },
    linkUrl(url) { //連結掛號 畫面
      if (url !== "" && this.isLink(url)) {
        const urlParams = new URLSearchParams(this.$store.state.AppSetting.backSrvUrl + '?' + url);
        let divName = urlParams.get('divName');
        this.$router.push({
          name: 'RegTan', query: {
            viewDate: this.splitURL("viewDate", url),
            apn: this.splitURL("apn", url),
            doctorNo: this.splitURL("doctorNo", url),
            zone: this.splitURL("zone", url),
            clinicNo: this.splitURL("clinicNo", url),
            doctorName: this.splitURL("doctorName", url),
            clinicName: this.splitURL("clinicName", url),
            divNo: this.splitURL("divNo", url),
            divName: divName
          }
        });
      }
    }
  }
}
</script>

<style scoped>
/* 表格容器 */
.clinic-table-container {
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow-x: auto;
  background-color: white;
  max-height: calc(85vh - 10px);
  border-bottom: 2px solid #fff;
  border-top: 2px solid #fff;
}

/* 表頭 */
.table-header {
  display: flex;
  position: sticky;
  top: 0;
  z-index: 2;
  background-color: #E8C4E7;
}

/* 表格行 */
.table-row {
  display: flex;
  border-bottom: 1px solid #f0f0f0;
}

/* 所有單元格的基本樣式 */
.cell {
  padding: 8px;
  flex-shrink: 0;
  border-right: 2px solid #fff;
  box-sizing: border-box;
}

/* 表頭單元格 */
.header-cell {
  flex: 1;
  min-width: 85px;
  padding: 10px 8px;
  font-weight: bold;
  border-bottom: 2px solid #fff;
  border-right: 2px solid #fff;
  background-color: #BFA2BE;
}

/* 第一列表頭固定 */
.first-column-header {
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: #BFA2BE; /* 使用與表格相同的黃色背景 */
}

/* 第一列固定 */
.clinic-cell {
  position: sticky;
  left: 0;
  z-index: 1;
  background-color: #BFA2BE; /* 使用與表格相同的黃色背景 */
}

/* 確保診間名稱底色與行底色一致 */
.table-row:nth-child(odd) .clinic-cell {
  background-color: #BFA2BE;
}

.table-row:nth-child(even) .clinic-cell {
  background-color: #BFA2BE;
}

/* 數據列 */
.data-cell {
  flex: 1;
  min-width: 85px;
  overflow: hidden;
  white-space: normal;
  word-break: break-word;
  background-color: #E8C4E7;
  border-bottom: 2px solid #fff;
}

/* 其他樣式 */
.divName {
  font-weight: bold;
  color: blue;
}

.linkName {
  text-decoration: underline;
  cursor: pointer;
}

.iconSmallFont {
  font-size: 16px !important;
}

/* 空數據提示 */
.no-data {
  padding: 20px;
  text-align: center;
}

.fixed-left {
  position: sticky;
  left: 0;
  z-index: 2;
  background-color: #f5f5f5; /* 根據你表格底色調整 */
}

/* 針對不同屏幕寬度的響應式調整 */
@media screen and (max-width: 768px) {
  .cell, .header-cell {
    min-width: 85px; /* 確保在小屏幕上有最小寬度 */
  }
}
</style>